import {
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';

import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

import { GIT_INFORMATION, type GitInformation } from './symbols';

export function withFlagsToolbarInformation(gitInformation: GitInformation) {
  return makeEnvironmentProviders([
    { provide: GIT_INFORMATION, useValue: gitInformation },
    provideEnvironmentInitializer(() => {
      const controls = inject(CosFeatureFlagsToolbarControlsSet);
      controls.add(async () => {
        const { CosFeatureFlagsToolbarInformationComponent } = await import(
          './feature-flags-toolbar-information.component'
        );
        return CosFeatureFlagsToolbarInformationComponent;
      });
    }),
  ]);
}
